import { render, staticRenderFns } from "./BlockchainDetails.vue?vue&type=template&id=6a2350e4&"
import script from "./BlockchainDetails.vue?vue&type=script&lang=js&"
export * from "./BlockchainDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports